import { Select2Test } from '@/test-components';

import { BootstrapSwitch } from '@/test-components';

import { InputText } from '@/test-components';

import { Password } from '@/test-components';

import { DateTimePicker } from '@/test-components';

import { RichText } from '@/test-components';

import { Textarea } from '@/test-components';

import { ColorPicker } from '@/test-components';

import { Location } from '@/test-components';

import { Radio } from '@/test-components';

import { Checkbox } from '@/test-components';

export const testingRoutes = [
    {
        path: '/test/select2/:test',
        component: Select2Test,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },
    {
        path: '/test/bootstrap-switch/:test',
        component: BootstrapSwitch,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },
    {
        path: '/test/input-text/:test',
        component: InputText,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },
    {
        path: '/test/password/:test',
        component: Password,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },
    {
        path: '/test/date-time-picker/:test',
        component: DateTimePicker,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },
    {
        path: '/test/rich-text/:test',
        component: RichText,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },
    {
        path: '/test/textarea/:test',
        component: Textarea,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },

    {
        path: '/test/color-picker/:test',
        component: ColorPicker,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },

    {
        path: '/test/location/:test',
        component: Location,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },

    {
        path: '/test/radio/:test',
        component: Radio,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },

    {
        path: '/test/checkbox/:test',
        component: Checkbox,
        meta: {
            onlyIfNotAuthenticated: false,
            sidebarWidthGroup: 'default',
        },
    },
];
